export const MAGIC_LINK_REDIRECT_PATH_LOCAL_STORAGE_KEY =
  'MAGIC_LINK_REDIRECT_PATH';
export const MAGIC_LINK_ORIGIN_LOCAL_STORAGE_KEY = 'MAGIC_LINK_ORIGIN';

export const MAGIC_LINK_LOGIN_BROADCAST_CHANNEL = 'MAGIC_LINK_LOGIN_CHANNEL';
export const MAGIC_LINK_LOGIN_BROADCAST_MESSAGE = 'MAGIC_LINK_LOGIN';

export enum MagicLinkFlow {
  Login = 'login',
  Signup = 'signup',
}

export const EMAIL_VERIFICATION_ID_SESSION_STORAGE_KEY = 'VERIFICATION_ID';
export const EMAIL_SESSION_STORAGE_KEY = 'EMAIL';
export const TOKEN_SESSION_STORAGE_KEY = 'TOKEN';

export const MAGIC_LINK_SESSION_STORAGE_KEYS = [
  EMAIL_VERIFICATION_ID_SESSION_STORAGE_KEY,
  EMAIL_SESSION_STORAGE_KEY,
  TOKEN_SESSION_STORAGE_KEY,
];

export const OPEN_EMAIL_APP_ACTION = 'openEmailApp';
export const MIN_NATIVE_CTAS_BUILD_VERSION = 260304160029;
